import React from "react";
import "./Reports.less";
import Grid from "@material-ui/core/Grid";
import { apiBatchRequest } from "../../utils/api_service";
import { API_URL } from "../../constants/api";
import ReportsTableNav from "./ReportsTableNav";
import Reporting from "./Reporting";
import ReportingSection from "./ReportingSection";
import { Button } from "@material-ui/core";
import ReportDataTable from "./ReportDataTable";

class ReportTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      getAllReports: [],
      reportId: 0,
      filterConfig: [],
      colFilteredObj: [],
      filterName: "",
      reload: false,
      fileName: null,
      reportName: null,
      isReportSection: false,
      reportSectionName: null,
      apiCalled: false,
      showReport: false,
      initialConfigData: [],
      isTooltipShow: false,
      toolTipData: [],
      eventInitiatedFrom: "",
      isInErrorState:false
    };
  }

  componentDidMount() {
    this.getAllReportData();
  }

  /**
   * Get report data
   */
  getAllReportData = () => {
    apiBatchRequest([
      {
        url: API_URL.reporting.getAllReports,
        key: "getAllReports"
      }
    ]).then(({ getAllReports }) => {
      const getAllSection = getAllReports?.rawData?.sort((a, b) =>
        a.ReportSortOrder > b.ReportSortOrder ? 1 : -1
      );
      const getAllReport = getAllReports?.data?.sort((a, b) =>
        a.SectionSortOrder > b.SectionSortOrder ? 1 : -1
      );
      this.setState({
        apiCalled: true,
        getAllReports: getAllReport,
        reportSectionId: getAllReport[0]?.ReportSectionId,
        reportSectionName: getAllReport[0]?.ReportSectionDisplayName,
        sectionFilterData: getAllSection
      });
    });
  };

  /**
   * render the UI according to tab selection and to show active report
   * @param {*} reportName -> name of report
   */
  changeActiveReport = reportName => {
    const { sectionFilterData, reportSectionId, reload } = this.state;

    this.setState({
      reportName: sectionFilterData?.find(
        x =>
          x.ReportDisplayName == reportName &&
          x.ReportSectionId == reportSectionId
      )?.ReportName,
      fileName: sectionFilterData?.find(
        x =>
          x.ReportDisplayName == reportName &&
          x.ReportSectionId == reportSectionId
      )?.DownloadFileName,
      reload: !reload,
      filterName: sectionFilterData?.find(
        x =>
          x.ReportDisplayName == reportName &&
          x.ReportSectionId == reportSectionId
      )?.ReportDisplayName,
      reportId: sectionFilterData?.find(
        x =>
          x.ReportDisplayName == reportName &&
          x.ReportSectionId == reportSectionId
      )?.ReportId,
      eventInitiatedFrom:  sectionFilterData?.find(
        x =>
          x.ReportDisplayName == reportName &&
          x.ReportSectionId == reportSectionId
      )?.InitiatedFrom
    });
  };

  /**
   * render the UI according to tab selection
   * @param {*} reportName -> name of report
   */
  changeSectionReport = reportName => {
    const { sectionFilterData, reload, getAllReports } = this.state;

    this.setState({
      reportName: sectionFilterData?.find(x => x.ReportSectionId == reportName)
        ?.ReportName,
      fileName: sectionFilterData?.find(x => x.ReportSectionId == reportName)
        ?.DownloadFileName,
      reportSectionId: getAllReports?.find(x => x.ReportSectionId == reportName)
        ?.ReportSectionId,
      reportSectionName: getAllReports?.find(
        x => x.ReportSectionId == reportName
      )?.ReportSectionDisplayName,
      reload: !reload,
      filterName: sectionFilterData?.find(x => x.ReportSectionId == reportName)
        ?.ReportDisplayName
    });
  };

  /**
   * get report list when click on parent report selection
   * @param {*} item
   */
  getReportBySection = item => {
    console.log(item, this.props)
    this.setState({
      isReportSection: true,
      reportSectionId: item.ReportSectionId,
      filterName: item.ReportSectionDisplayName,
      fileName: item.DownloadFileName,
      reportName: item.ReportName
    });
  };

  /**
   * call when click on back button
   */
  backToSection = () => {
    this.setState({ isReportSection: false });
  };

  /**
   * load or view details report when click view button
   * @param {*} isShow -> show view report
   * @param {*} filterConfig -> filter config data
   * @param {*} colFilteredObj -> selected filter data
   * @param {*} dateTypeSelected -> type of slider
   * @param {*} initialConfigData -> original filter config data
   */
  loadUi = (
    isShow = false,
    filterConfig,
    colFilteredObj,
    dateTypeSelected,
    initialConfigData,
    isTooltipShow,
    toolTipData
  ) => {
    this.setState({
      showReport: isShow,
      filterConfig,
      colFilteredObj,
      dateTypeSelected,
      initialConfigData,
      isTooltipShow,
      toolTipData
    });
  };

  onError = (value,message) => {
    // let colFiltered = this.state.colFilteredObj?.filter(e => {
    //   if (e.keyName !== key) return e;
    // });
    this.setState({
       isInErrorState: value,
       errorMessage:message
     });
  };
  render() {
    const {
      isReportSection,
      reportId,
      sectionFilterData,
      getAllReports,
      reportSectionId,
      reload,
      filterName,
      fileName,
      reportName,
      reportSectionName,
      showReport,
      filterConfig,
      colFilteredObj,
      dateTypeSelected,
      initialConfigData,
      isTooltipShow,
      toolTipData,
      apiCalled,
      eventInitiatedFrom     
    } = this.state;

    const { userData } = this.props;

    return (
      <>
        {!showReport && getAllReports && getAllReports.length > 0 ? (
          <Grid container className={"report-wrapper"}>
            <>
              {isReportSection ? (
                <Grid item xs={12}>
                  <div className={" report-flex-statement-div"}>
                    <div className={"reports-nav-wrapper"}>
                      <Button
                        className={"cancel-runReport-btn"}
                        variant={"contained"}
                        onClick={() => {
                          this.backToSection();
                        }}
                      >
                        {"Back\r"}
                      </Button>
                      <ReportsTableNav
                        reportsNavList={sectionFilterData.filter(m => {
                          if (m.ReportSectionId === reportSectionId) return m;
                        })}
                        onNavClick={this.changeActiveReport}
                      />
                    </div>
                    <Reporting
                      userData={userData.email}
                      reportSectionName={reportSectionName}
                      fileName={fileName}
                      reportName={reportName}
                      filterName={filterName}
                      reportSectionId={reportSectionId}
                      reportId={reportId}
                      reload={reload}
                      loadUi={this.loadUi}
                      eventInitiatedFrom={eventInitiatedFrom}
                      onError={this.onError}
                      isInErrorState={this.state.isInErrorState}
                      errorMessage={this.state.errorMessage}
                    />
                  </div>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <div className={" report-flex-statement-div"}>
                    <div className={"reports-breadcrumb-wrapper"}>
                      <span className={"reports-breadcrumb"}>
                        {"HOME | REPORT"}
                      </span>
                    </div>
                    <div className={"reports-nav-wrapper"}>
                      <ReportingSection
                        getReportBySection={this.getReportBySection}
                        reportsNavList={getAllReports}
                        onNavClick={this.changeSectionReport}
                      />
                    </div>
                  </div>
                </Grid>
              )}
            </>
          </Grid>
        ) : (
          !showReport &&
          apiCalled && (
            <Grid container spacing={4}>
              <Grid
                style={{ paddingBottom: "15px" }}
                container
                direction={"row-reverse"}
                justifyContent={"center"}
                alignItems={"stretch"}
              >
                <label className={"item-msg"}>
                  {"Don"}&apos;
                  {
                    "t have permission to view reports, please contact administrator for access.\r"
                  }
                </label>
              </Grid>
            </Grid>
          )
        )}
        {showReport && (
          <ReportDataTable
            reportName={reportName}
            loadUi={this.loadUi}
            filterConfig={filterConfig}
            reportSectionId={reportSectionId}
            colFilteredObj={colFilteredObj}
            reportId={reportId}
            fileName={fileName}
            filterName={filterName}
            dateTypeSelected={dateTypeSelected}
            initialConfigData={initialConfigData}
            isTooltipShow={isTooltipShow}
            toolTipData={toolTipData}
            userData={userData.email}
            eventInitiatedFrom={eventInitiatedFrom}
          />
        )}
      </>
    );
  }
}

export default ReportTable;
